import type { Template } from '@tunasong/plugin-lib'
import type { Poll } from '@tunasong/schemas'
import groupedTemplate from './template-grouped.js'
import rehearsalTemplate from './template-rehearsal.js'
import template from './template.js'

export const pollTemplates: Template<Poll>[] = [
  { name: 'Poll', template },
  {
    name: 'Rehearsal poll',
    /** Without this the picker falls back to the plugin description and both cards read "Poll". */
    description: 'Find a night the band can play',
    template: rehearsalTemplate,
  },
  {
    name: 'Pick one per group',
    description: 'Choose a favourite from each group, e.g. the best song on each album',
    template: groupedTemplate,
  },
]
